<div class="video-container" *ngIf="videoUrl && isDirectVideoFile(videoUrl)">
    <video controls [src]="videoUrl">
      Your browser does not support the video tag.
    </video>
  </div>
  <div *ngIf="!videoUrl">
    No video URL provided.
  </div>
  